export function mean(nums: number[]): number {
  if (nums.length === 0) return 0;
  return nums.reduce((a, b) => a + b, 0) / nums.length;
}

export function stdDev(nums: number[]): number {
  if (nums.length < 2) return 0;
  const m = mean(nums);
  return Math.sqrt(mean(nums.map((x) => (x - m) ** 2)));
}

/**
 * A Y-axis domain that clips extreme outliers: 1st..99th percentile with 10%
 * padding. Without it a single spike flattens the whole trace against the axis.
 */
export function percentileDomain(
  values: number[],
  pLow = 0.01,
  pHigh = 0.99
): [number, number] {
  if (values.length === 0) return [0, 1];
  const sorted = [...values].sort((a, b) => a - b);
  const lo = sorted[Math.floor(sorted.length * pLow)];
  const hi = sorted[Math.ceil(sorted.length * pHigh) - 1];
  const range = hi - lo || 1;
  const pad = range * 0.1;
  return [Math.floor(lo - pad), Math.ceil(hi + pad)];
}
